module.exports = __webpack_public_path__ + "static/media/report-content-icon.c52dce1f.svg";